import React from 'react';
import { 
    translate,
    Filter,
    List, 
    Datagrid,
    TextField, 
    TextInput,
    Create,
    SelectInput,
    EditButton,
    ShowButton,
} from 'react-admin';
import Chip from '@material-ui/core/Chip';
import withStyles from '@material-ui/core/styles/withStyles';
import BoolNumField from './BoolNumField'
import LinkToPassword from './LinkToPassword';
import ErrorBoundary from '../ErrorBoundary';


const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
};

const QuickFilter = translate(
    withStyles(quickFilterStyles)(({ classes, label, translate }) => (
        <Chip className={classes.root} label={translate(label)} />
    ))
);

export const UserFilter = props => (
    <Filter {...props}>
        
        <TextInput source="full_name" alwaysOn label='Name'/>
        <TextInput source="name"   label='Site Name'/>
        <SelectInput source="title" lable ='Title' allowEmpty emptyValue="" choices={[
            { id: 'User', name: 'User' },
            { id: 'Operator', name: 'Operator' },
            { id: 'QA User', name: 'QA User' },
            { id: 'QA Manager', name: 'QA Manager' },
            { id: 'Site Manager', name: 'Site Manager' }
        ]} />
    </Filter>
);

export const UserList = props => (
<ErrorBoundary>  
    <List 
        {...props}
        filters={<UserFilter />}
        perPage={20}
        sort={{ field: 'full_name', order: 'ASC' }}
        bulkActionButtons ={false}
        >
        <Datagrid    >
            <TextField source="full_name" label="Name" />
            <TextField source="title" label="Title"/>     
            <TextField source="user_name" label="Login ID" />
            <BoolNumField source="is_active" label="Is Active?" />
            <LinkToPassword />
            <ShowButton />
            <EditButton  />
        </Datagrid>
    </List>
    </ErrorBoundary>  
);


export default UserList